import { render, staticRenderFns } from "./ManagementFeeForm.vue?vue&type=template&id=57f071a6"
import script from "./ManagementFeeForm.vue?vue&type=script&lang=js"
export * from "./ManagementFeeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports